import { removeErrorStackInitiator } from './removeStackInitiator'

export function invariant(err: string | Error): never {
  if (err instanceof Error) throw err
  const error = new Error(err)
  removeErrorStackInitiator(error)
  throw error
}
